import React, { useRef } from 'react';
import classNames from 'classnames';
import { ResizableColumnIcon } from '@icons';
import './ResizableTitle.less';

function ResizableTitle({
  onResize,
  width,
  minWidth = 100,
  className,
  children,
  ...rest
}: React.ThHTMLAttributes<HTMLTableCellElement> & {
  width?: number;
  minWidth?: number;
  onResize?: (width: number) => void;
}) {
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  if (!width || !onResize) {
    return (
      <th {...rest} className={className}>
        {children}
      </th>
    );
  }

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const handle = e.currentTarget as HTMLElement;
    startXRef.current = e.clientX;
    startWidthRef.current = width;
    handle.classList.add('table-column-resize-handle--active');
    document.body.classList.add('table-column-resizing');

    const onMouseMove = (ev: MouseEvent) => {
      const nextWidth = Math.max(
        minWidth,
        startWidthRef.current + (ev.clientX - startXRef.current)
      );
      onResize(nextWidth);
    };

    const onMouseUp = () => {
      handle.classList.remove('table-column-resize-handle--active');
      document.body.classList.remove('table-column-resizing');
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <th
      {...rest}
      className={classNames(className, 'ant-table-cell--resizable')}
      style={{ ...rest.style, width, minWidth: width, maxWidth: width }}
    >
      {children}
      <span
        className="table-column-resize-handle b-ignore-marquee"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={onMouseDown}
      >
        <ResizableColumnIcon className="table-column-resize-handle__icon" />
      </span>
    </th>
  );
}

export default ResizableTitle;
